export function createVec3(x = 0, y = 0, z = 0) {
    return { x, y, z };
}
export function copyVec3(v) {
    return { x: v.x, y: v.y, z: v.z };
}
export function setVec3(out, x, y, z) {
    out.x = x;
    out.y = y;
    out.z = z;
    return out;
}
export function addVec3(a, b) {
    return { x: a.x + b.x, y: a.y + b.y, z: a.z + b.z };
}
export function subVec3(a, b) {
    return { x: a.x - b.x, y: a.y - b.y, z: a.z - b.z };
}
export function scaleVec3(v, s) {
    return { x: v.x * s, y: v.y * s, z: v.z * s };
}
export function dotVec3(a, b) {
    return a.x * b.x + a.y * b.y + a.z * b.z;
}
export function lengthSqVec3(v) {
    return v.x * v.x + v.y * v.y + v.z * v.z;
}
export function lengthVec3(v) {
    return Math.sqrt(lengthSqVec3(v));
}
export function normalizeVec3(v) {
    const len = lengthVec3(v);
    if (len < 1e-6)
        return { x: 0, y: 0, z: 0 };
    return { x: v.x / len, y: v.y / len, z: v.z / len };
}
export function crossVec3(a, b) {
    return {
        x: a.y * b.z - a.z * b.y,
        y: a.z * b.x - a.x * b.z,
        z: a.x * b.y - a.y * b.x,
    };
}
export function distanceVec3(a, b) {
    return lengthVec3(subVec3(a, b));
}
export function lerpVec3(a, b, t) {
    return {
        x: a.x + (b.x - a.x) * t,
        y: a.y + (b.y - a.y) * t,
        z: a.z + (b.z - a.z) * t,
    };
}
export function clamp(val, min, max) {
    return Math.max(min, Math.min(max, val));
}
export function lerp(a, b, t) {
    return a + (b - a) * t;
}
export function normalizeAngle(angle) {
    let a = angle % (2 * Math.PI);
    if (a > Math.PI)
        a -= 2 * Math.PI;
    if (a < -Math.PI)
        a += 2 * Math.PI;
    return a;
}
export function angleDifference(target, current) {
    return normalizeAngle(target - current);
}
//# sourceMappingURL=math.js.map